import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

const logoContainerStyle = {
  margin: '.84rem 0 0 .6875rem',
  width: '18px',
  height: '18px',
};

const textContainerStyle = {
  display: 'inline-block',
  marginLeft: '.375rem',
  marginRight: 0,
  color: 'rgb(247, 247, 247)',
  letterSpacing: '.013125rem',
  paddingLeft: '.625rem',
  paddingRight: '.625rem',
  fontSize: '.875rem',
  lineHeight: '3rem',
  verticalAlign: 'top',
};

const FacebookButton = ({ facebookLogoURL, label, t }) => {
  return (
    <div>
      <img alt="" style={logoContainerStyle} src={facebookLogoURL} />
      <span style={textContainerStyle}>{t(label)}</span>
    </div>
  );
};

FacebookButton.defaultProps = {
  facebookLogoURL: '/images/f.svg',
};

FacebookButton.propTypes = {
  facebookLogoURL: PropTypes.string,
};

export default withTranslation()(FacebookButton);
